var cilBritishPound = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M375.942,160a88.042,88.042,0,0,0-176.033,3.024v76.588H136v32h63.909v120.3H136v32H376v-32H231.909v-120.3H344v-32H231.909V163.024a56.046,56.046,0,0,1,112.091,0V168h32v-8Z' class='ci-primary'/>"];

export { cilBritishPound };

